import React from 'react';
import { Button, Paper } from '@mui/material';
import { Redo, Undo } from '@mui/icons-material';
import chartingMenuSx from './ChartingMenu.styles';
import { useTheme } from '@mui/material/styles';
import MenuLayers from './MenuLayers';
import MenuTeeth from './MenuTeeth';
import MenuMarkup from './MenuMarkup';
import MenuDeleteMove from './MenuDeleteMove';
import MenuExtras from './MenuExtras';
import MenuSymbols from './MenuSymbols';
import AllSymbolsDialog from './AllSymbolsDialog';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../Chart.redux';
import useChartAutoSave from 'hooks/useChartAutoSave';
import MenuSave from './MenuSave';

const ChartingMenu = () => {
    const theme = useTheme();
    const sx = chartingMenuSx(theme);
    const dispatch = useDispatch();
    const saving = useSelector((state) => state.chart.saving);

    const [autoSaveEnabled, autoSaveInterval, autoSaveProgress, resetAutoSaveTimer] = useChartAutoSave();

    return (
        <Paper elevation={2} sx={sx.menuContainer}>
            <MenuLayers />
            <MenuTeeth />
            <MenuSymbols />
            <MenuMarkup />
            <MenuExtras />
            <MenuDeleteMove />
            <AllSymbolsDialog />

            <Button
                variant="outlined"
                sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
                onClick={() => dispatch(actions.undoRedo('UNDO'))}
            >
                <Undo />
            </Button>

            <Button
                variant="outlined"
                sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
                onClick={() => dispatch(actions.undoRedo('REDO'))}
            >
                <Redo />
            </Button>

            <MenuSave
                saving={saving}
                autoSaveEnabled={autoSaveEnabled}
                autoSaveInterval={autoSaveInterval}
                autoSaveProgress={autoSaveProgress}
                onSave={resetAutoSaveTimer}
            />
        </Paper>
    );
};

export default ChartingMenu;
